import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    section: {
        maxWidth: 1280,
        margin: theme.spacing(0, "auto", 8),
        padding: theme.spacing(5, 2),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            maxWidth: 600,
        },
    },
    sectionTitle: {
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(5),
    },
    accordionsWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
    },
    paragraphs: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
        color: theme.palette.secondary.main,
    },
}));
